import { __decorate } from "tslib";
import { html, LitElement, nothing } from "lit";
import { property, state } from "lit/decorators.js";
import { connect, store } from "lxl-data";
import { selectConfig } from "lxl-data/config";
export class LxlConnectedElement extends connect(store)(LitElement) {
    constructor() {
        super(...arguments);
        this._locale = 'en';
        this.queryArgs = {};
        this.isLoading = false;
        this.isSuccess = false;
        this.isUninitialized = true;
        this.assetsUrl = '';
        this.assetsGlobalUrl = '';
    }
    set locale(locale) {
        const oldValue = this.locale;
        this._locale = locale;
        this.requestUpdate("locale", oldValue);
        if (!!this.jwt && !!this._locale && oldValue) {
            this.fetchData();
        }
    }
    ;
    get locale() {
        return this._locale;
    }
    set jwt(jwt) {
        const oldValue = this.jwt;
        this._jwt = jwt;
        this.requestUpdate("jwt", oldValue);
        if (!!this._jwt && !!this.locale && oldValue) {
            this.fetchData();
        }
    }
    get jwt() {
        return this._jwt;
    }
    connectedCallback() {
        super.connectedCallback();
        this.fetchData();
    }
    loadDictionary(dictionary) {
        this.dictionary = dictionary;
        this.requestUpdate();
    }
    localize(key, args) {
        if (!this.dictionary) {
            return;
        }
        if (this.dictionary[key]) {
            if (args) {
                return this.dictionary[key].replace(/%{([0-9])}/g, (_, placeholder) => {
                    return args[placeholder];
                });
            }
            else {
                return this.dictionary[key];
            }
        }
        return "-";
    }
    fetchData() {
        if (this.query) {
            store.dispatch(this.query.initiate(Object.assign({ locale: this.locale, jwt: this.jwt }, this.queryArgs)));
        }
    }
    fetchRetry() {
        if (this.query) {
            store.dispatch(this.query.initiate(Object.assign({ locale: this.locale, jwt: this.jwt }, this.queryArgs)));
            this.requestUpdate();
        }
    }
    stateChanged(_state) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (this.selector) {
            this.data = this.selector(_state);
        }
        if (this.query) {
            const { data, isLoading, isSuccess, isUninitialized, status, error } = this.query.select(Object.assign({ locale: this.locale, jwt: this.jwt }, this.queryArgs))(_state);
            if (data === null || data === void 0 ? void 0 : data.dictionary) {
                this.loadDictionary(data === null || data === void 0 ? void 0 : data.dictionary);
            }
            else if ((_a = selectConfig(_state)) === null || _a === void 0 ? void 0 : _a.dictionary) {
                this.loadDictionary(selectConfig(_state).dictionary);
            }
            this.isLoading = isLoading;
            this.isSuccess = isSuccess;
            this.isUninitialized = isUninitialized;
            this.status = status;
            this.error = error;
            this.assetsUrl = `${((_c = (_b = this.data) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.assetsPrefix) || ''}/assets/banner/${(_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.config) === null || _e === void 0 ? void 0 : _e.banner}`;
            this.assetsGlobalUrl = `${(_g = (_f = this.data) === null || _f === void 0 ? void 0 : _f.config) === null || _g === void 0 ? void 0 : _g.assetsPrefix}/assets/global`;
        }
    }
    render() {
        if (this.isLoading) {
            setTimeout(() => {
                if (this.clientHeight) {
                    this.skeletonHeight = this.clientHeight;
                }
            });
            return this.lxlConnectedLoadingRender();
        }
        if (this.error) {
            return this.lxlConnectedErrorRender();
        }
        return this.lxlConnectedRender();
    }
    lxlConnectedErrorRender() {
        return html `
      <lxl-component-error 
        lxl-error-title=${this.localize('LXL_COMPONENTS_ERROR_TITLE')}
        lxl-error-subtitle=${this.localize('LXL_COMPONENTS_ERROR_SUBTITLE')}
        lxl-error-action=${this.localize('LXL_COMPONENTS_ERROR_ACTION')}
        locale=${this.locale}
        jwt=${this.jwt}
        style="
          display: block;  
          ${this.skeletonHeight ? `height: ${this.skeletonHeight}px` : nothing}" 
          @lxlcomponenterrorretry="${() => this.fetchRetry()}"
      >
      </lxl-component-error>`;
    }
    lxlConnectedRender() { }
}
__decorate([
    property({ reflect: true, type: String })
], LxlConnectedElement.prototype, "locale", null);
__decorate([
    property({ reflect: true, type: String })
], LxlConnectedElement.prototype, "jwt", null);
__decorate([
    state()
], LxlConnectedElement.prototype, "isLoading", void 0);
__decorate([
    state()
], LxlConnectedElement.prototype, "isSuccess", void 0);
__decorate([
    state()
], LxlConnectedElement.prototype, "isUninitialized", void 0);
__decorate([
    state()
], LxlConnectedElement.prototype, "status", void 0);
__decorate([
    state()
], LxlConnectedElement.prototype, "data", void 0);
__decorate([
    state()
], LxlConnectedElement.prototype, "error", void 0);
__decorate([
    state()
], LxlConnectedElement.prototype, "assetsUrl", void 0);
__decorate([
    state()
], LxlConnectedElement.prototype, "assetsGlobalUrl", void 0);
//# sourceMappingURL=lxl-connected-element.js.map